/* eslint-disable */
/*
* vacations.js
*
* Description: Holds 'Stores' Logic for Module:'Vacations'.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew - Vacations"
* Copyright 2018,2019,2020 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';
import dayjs from 'dayjs';
import {
    CONF_SCHEDULER_TIME_RANGE_DAYS
} from '../../../config.js'


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> vacations resources-----------------------------
    vacations_resourcesOfDepartment: [],
    vacations_resourcesOfDepartment_Filtered: [],
    vacations_fullMemberName: 'ONE MOMENT. STILL LOADING..',
    vacations_resourceId: null,
    vacations_selectedYear: null,
    // >>> vacations vacations ----------------------------
    vacations_vacationsOfResource: [],
    vacations_numberOfVacations: 0,
    // >>> vacations offdays ------------------------------
    vacations_offdaysOfResource: [],
    vacations_numberOfOffdays: 0,
    // >>> vacations illness ------------------------------
    vacations_illnessOfResource: [],
    vacations_numberOfIllness: 0,
    // >>> vacations illness ------------------------------
    vacations_unableToFlyOfResource: [],
    vacations_numberOfUnableToFly: 0,
    // >>> vacations combined -----------------------------
    vacations_combinedVacations: [],
    // >>> vacations resource info ------------------------
    vacations_activeResourceInformations: null,
    vacations_activeResourceContractVacationDays : 0,
    vacations_activeResourceContractOffdayDays : 0,
    vacations_activeResourceGenChildren : 0,
    vacations_activeResourceGenChildrenSchool : 0,
    // >>> vacations report -------------------------------
    vacations_vacationReport: [],
    // >>> vacations ssearch params -----------------------
    vacations_searchchParamsResource : null,
    vacations_searchchParams : {
        "baseCodes": null,
        "fromDate": dayjs().format('YYYY-MM-DD') + 'T02:00:00+0200',
        "idresources": null,
        "positions": null,
        "status": null,
        "toDate": dayjs().add(CONF_SCHEDULER_TIME_RANGE_DAYS, 'days').format('YYYY-MM-DD') + 'T02:00:00+0200',
        "types": null
    },
    // >>> call counter -----------------------------------
    vacations_callCounter: 0,

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Vacations' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * get_ResourcesOfDepartment()
    *
    * Desc: Returns Resources of both Deoartments.
    * Note:
    *
    */
    get_ResourcesOfDepartment: state => {

        return state.vacations_resourcesOfDepartment;

    }, // eo function get_ResourcesOfDepartment()


    /***************************************************************************
    * get_FullMemberName()
    *
    * Desc: Returns the full name of the Resource.
    * Note:
    *
    */
    get_FullMemberName: state => {

        if (state.vacations_fullMemberName !== undefined) {
            return state.vacations_fullMemberName;
        }
        if (state.vacations_fullMemberName === undefined) {
            return 'ONE MOMENT. STILL LOADING..';
        }



    }, // eo function get_FullMemberName()


    /***************************************************************************
    * get_idResource()
    *
    * Desc: Returns the id of the Resource.
    * Note:
    *
    */
    get_idResource: state => {

        return state.vacations_resourceId;

    }, // eo function get_idResource()


    /***************************************************************************
    * get_selectedYear()
    *
    * Desc:
    * Note:
    *
    */
    get_selectedYear: state => {

        return state.vacations_selectedYear;

    }, // eo function get_selectedYear()


    /***************************************************************************
    * get_NumberOfVacations()
    *
    * Desc: Returns Vacations of Resource.
    * Note:
    *
    */
    get_NumberOfVacations: state => {

        return state.vacations_numberOfVacations;

    }, // eo function get_NumberOfVacations()


    /***************************************************************************
    * get_NumberOfOffdays()
    *
    * Desc: Returns Offdays of Resource.
    * Note:
    *
    */
    get_NumberOfOffdays: state => {

        return state.vacations_numberOfOffdays;

    }, // eo function get_NumberOfOffdays()


    /***************************************************************************
    * get_NumberOfIllness()
    *
    * Desc: Returns Illness of Resource.
    * Note:
    *
    */
    get_NumberOfIllness: state => {

        return state.vacations_numberOfIllness;

    }, // eo function get_NumberOfIllness()


    /***************************************************************************
    * get_NumberOfUnableToFly()
    *
    * Desc: Returns Unable to fly of Resource.
    * Note:
    *
    */
    get_NumberOfUnableToFly: state => {

        return state.vacations_numberOfUnableToFly;

    }, // eo function get_NumberOfUnableToFly()


    /***************************************************************************
    * get_CombinedVacationsOfResource()
    *
    * Desc: Returns all Calls combined Data.
    * Note:
    *
    */
    get_CombinedVacationsOfResource: state => {

        return state.vacations_combinedVacations;

    }, // eo function get_CombinedVacationsOfResource()




    /***************************************************************************
    * Getters: 'Ressource' - Load Ressource
    ***************************************************************************/
    /***************************************************************************
    * get_ActiveResourceContractVacationDays()
    *
    * Desc:
    * Note:
    *
    */
    get_ActiveResourceContractVacationDays: state => {

        return state.vacations_activeResourceContractVacationDays;

    }, // eo function get_ActiveResourceContractVacationDays()

    /***************************************************************************
    * get_ActiveResourceContractOffdayDays()
    *
    * Desc:
    * Note:
    *
    */
    get_ActiveResourceContractOffdayDays: state => {

        return state.vacations_activeResourceContractOffdayDays;

    }, // eo function get_ActiveResourceContractOffdayDays()

    /***************************************************************************
    * get_ActiveResourceGenChildren()
    *
    * Desc:
    * Note:
    *
    */
    get_ActiveResourceGenChildren: state => {

        return state.vacations_activeResourceGenChildren;

    }, // eo function get_ActiveResourceGenChildren()

    /***************************************************************************
    * get_ActiveResourceGenChildrenSchool()
    *
    * Desc:
    * Note:
    *
    */
    get_ActiveResourceGenChildrenSchool: state => {

        return state.vacations_activeResourceGenChildrenSchool;

    }, // eo function get_ActiveResourceGenChildrenSchool()




    /***************************************************************************
    * Getters: 'Vacation Report'
    ***************************************************************************/
    /***************************************************************************
    * get_VacationReport()
    *
    * Desc:
    * Note:
    *
    */
    get_VacationReport: state => {

        return state.vacations_vacationReport;

    }, // eo function get_VacationReport()

};





//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Vacations' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * mut_reset_ResourcesOfDepartment()
    *
    * Desc: Reset Resources.
    * Note:
    *
    */
    mut_reset_ResourcesOfDepartment: (state, payload) => {

        state.vacations_resourcesOfDepartment = [];

    }, // eo function mut_reset_ResourcesOfDepartment()




    /***************************************************************************
    * Mutations: 'Vacations' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * mut_set_ResourcesOfDepartment()
    *
    * Desc: Set Resources of Department from Calls Reponse.
    * Note: There are to simultaneously Department Calls.
    * Note: Therefore this is a 'stupid' Hack here.
    * Note: Build 'filterableName'.
    * Note: Build fullMemberName for MemberMode.
    *
    */
    mut_set_ResourcesOfDepartment: (state, payload) => {

        const idResource = payload.context.rootState.shared.idResource;
        let filterableName = null,
            fullName = null;


        payload.response = payload.response.filter(r => r.active === true);
        if (state.vacations_resourcesOfDepartment.length === 0) { // first load
            state.vacations_resourcesOfDepartment = payload.response;
        } else {
            state.vacations_resourcesOfDepartment = state.vacations_resourcesOfDepartment.concat(payload.response);
            eventBus.$emit('departmentsareloaded');

        }
        state.vacations_resources_Filtered = state.vacations_resourcesOfDepartment;



        // >>> Add 'onKeyup_filterResources' ----
        state.vacations_resources_Filtered.forEach((item) => {
            filterableName = item.genLastname.trim() + ', ' + item.genFirstName.trim() + ' (' + item.contract3Code + ')';
            item.filterableName = filterableName;
            fullName = item.genLastname.trim() + ', ' + item.genFirstName.trim() + ' (' + item.contract3Code + ')'
            item.fullName = fullName;

            item.wasEdited = false;

            if (idResource === item.id) {
                state.vacations_fullMemberName = fullName;
            }

        });


        // eventBus.$emit('departmentsareloaded');

    }, // eo function mut_set_ResourcesOfDepartment()


    /***************************************************************************
    * mut_call_createSingleVacations()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_createSingleVacations: (state, payload) => {

        state.vacations_vacationsOfResource = state.vacations_vacationsOfResource.concat(payload.payload);
        payload.context.commit('mut_set_CombinedVacations');

        eventBus.$emit('vacationsCreated');

    }, // eo function mut_call_createSingleVacations()


    /***************************************************************************
    * mut_call_createMultiVacations()
    *
    * Desc:
    * Note: Reacts on 'update' || 'create'. #616
    *
    */
    mut_call_createMultiVacations: (state, payload) => {

        if (payload.editorMode === 'create') {
            state.vacations_vacationsOfResource = state.vacations_vacationsOfResource.concat(payload.payload);
        }

        if (payload.editorMode === 'update') {
                payload.payload.forEach(itemouter => {
                    state.vacations_vacationsOfResource.forEach((iteminner, index) => {
                        if (itemouter.id === iteminner.id) {
                            state.vacations_vacationsOfResource.splice(index, 1);
                        }
                    });
                });

            state.vacations_vacationsOfResource = state.vacations_vacationsOfResource.concat(payload.payload);
        }


        payload.context.commit('mut_set_CombinedVacations');
        eventBus.$emit('vacationsCreated');

    }, // eo function mut_call_createMultiVacations()


    /***************************************************************************
    * mut_call_deleteVacations()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_deleteVacations: (state, payload) => {

        let index_vacationsOfResource = state.vacations_vacationsOfResource.findIndex(v => v.id === payload.payload.id),
            index_unbaleToFlyOfResource = state.vacations_unableToFlyOfResource.findIndex(v => v.id === payload.payload.id),
            index_combinedVacations = state.vacations_combinedVacations.findIndex(v => v.id === payload.payload.id);


        if (index_vacationsOfResource > -1) {
            state.vacations_vacationsOfResource.splice(index_vacationsOfResource, 1);
        }
        if (index_unbaleToFlyOfResource > -1) {
            state.vacations_unableToFlyOfResource.splice(index_unbaleToFlyOfResource, 1);
        }
        state.vacations_combinedVacations.splice(index_combinedVacations, 1);

    }, // eo function mut_call_deleteVacations()


    /***************************************************************************
    * mut_call_deleteMultiVacations()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_deleteMultiVacations: (state, payload) => {

        state.vacations_vacationsOfResource = state.vacations_vacationsOfResource.filter(v => !payload.payload.idBreaks.includes(v.id));
        state.vacations_unableToFlyOfResource = state.vacations_unableToFlyOfResource.filter(v => !payload.payload.idBreaks.includes(v.id));
        state.vacations_offdaysOfResource = state.vacations_offdaysOfResource.filter(v => !payload.payload.idBreaks.includes(v.id));

        payload.context.commit('mut_set_CombinedVacations');

    }, // eo function mut_call_deleteMultiVacations()




    /***************************************************************************
    * Mutations: 'Vacations' - Load single Duties.
    ***************************************************************************/
    /***************************************************************************
    * mut_set_VacationsOfResource()
    *
    * Desc: Set Vacation of Resources.
    *
    */
    mut_set_VacationsOfResource: (state, payload) => {

        state.vacations_callCounter = ++state.vacations_callCounter; // add call counter
        state.vacations_vacationsOfResource = payload.payload;

        payload.context.commit('mut_set_CombinedVacations');

    }, // eo function mut_set_VacationsOfResource()


    /***************************************************************************
    * mut_set_OffdaysOfResource()
    *
    * Desc: Set Offdays of Resources.
    *
    */
    mut_set_OffdaysOfResource: (state, payload) => {

        state.vacations_callCounter = ++state.vacations_callCounter; // add call counter
        state.vacations_offdaysOfResource = payload.payload;

        payload.context.commit('mut_set_CombinedVacations');

    }, // eo function mut_set_OffdaysOfResource()


    /***************************************************************************
    * mut_set_IllnessOfResource()
    *
    * Desc: Set Illness of Resources.
    *
    */
    mut_set_IllnessOfResource: (state, payload) => {

        state.vacations_callCounter = ++state.vacations_callCounter; // add call counter
        state.vacations_illnessOfResource = payload.payload;

        payload.context.commit('mut_set_CombinedVacations');

    }, // eo function mut_set_IllnessOfResource()



    /***************************************************************************
    * mut_call_getUnableToFlyOfResource()
    *
    * Desc: Set Illness of Resources.
    *
    */
    mut_call_getUnableToFlyOfResource: (state, payload) => {

        state.vacations_callCounter = ++state.vacations_callCounter; // add call counter
        state.vacations_unableToFlyOfResource = payload.payload;

        payload.context.commit('mut_set_CombinedVacations');

    }, // eo function mut_call_getUnableToFlyOfResource()


    /***************************************************************************
    * mut_set_CombinedVacations()
    *
    * Desc: Combine all Duties.
    * Note: Only if all 3 Calls are finished.
    * Note: Build single 'Days' for Date Ranges.
    *
    */
    mut_set_CombinedVacations: (state, payload) => {

        let combinedVacations = [],
            combinedAddedVacations = [],
            sumDaysBetween = 0,
            className = null,
            numberOfVacations = 0,
            numberOfOffdays = 0,
            numberofIllness = 0,
            numberOfUnableToFly = 0;


        if (state.vacations_callCounter === 4) { // 4 Calls = Illness, Vacations, Offdays, UnableToFly
            combinedVacations = state.vacations_vacationsOfResource.concat(state.vacations_offdaysOfResource).concat(state.vacations_illnessOfResource).concat(state.vacations_unableToFlyOfResource);

            for (let i = 0; i < combinedVacations.length; i++) {

                // >>> find color ---------------
                if (combinedVacations[i].type === "VACATION") {
                    className = 'vacation';
                } else if (combinedVacations[i].type === "DAYOFF" || combinedVacations[i].type === "FREEDAY") {
                    className = 'dayoff';
                } else if (combinedVacations[i].type === "SICKNESS") {
                    className = 'sickness';
                } else if (combinedVacations[i].type === "UNABLEFLIGHT") {
                    className = 'unabletofly';
                } else {
                    className = 'grey';
                }


                // >>> build single days --------
                if (dayjs(combinedVacations[i].from).isSame(dayjs(combinedVacations[i].to), 'day') === true) {
                    combinedAddedVacations.push({date: dayjs(combinedVacations[i].from).format('YYYY-MM-DD'), className: className, id: combinedVacations[i].id, comment: combinedVacations[i].dutyComment });
                } else {
                    sumDaysBetween = dayjs(combinedVacations[i].to).diff(dayjs(combinedVacations[i].from), 'day');
                    for(let x = 0; x <= sumDaysBetween; x++) { // single days from range
                        combinedAddedVacations.push({date: dayjs(combinedVacations[i].from).add(x, 'day').format('YYYY-MM-DD'), className: className, id: combinedVacations[i].id, comment: combinedVacations[i].dutyComment  });
                    }

                }

            }

            combinedAddedVacations.map((vacation) => {
                if (vacation.className === "vacation") {
                    numberOfVacations = ++numberOfVacations;
                }
                if (vacation.className === "dayoff") {
                    numberOfOffdays = ++numberOfOffdays;
                }
                if (vacation.className === "sickness") {
                    numberofIllness = ++numberofIllness;
                }
                if (vacation.className === "unabletofly") {
                    numberOfUnableToFly = ++numberOfUnableToFly;
                }
            });

            state.vacations_combinedVacations = combinedAddedVacations; // set state
            state.vacations_numberOfVacations = numberOfVacations;
            state.vacations_numberOfOffdays = numberOfOffdays;
            state.vacations_numberOfIllness = numberofIllness;
            state.vacations_numberOfUnableToFly = numberOfUnableToFly;


            Vue.prototype.$vp_um(); // unmask
            eventBus.$emit('combinedvacationsdone');
        }

    }, // eo function mut_set_CombinedVacations()





    /***************************************************************************
    * Mutations: 'Ressource' - Load Ressource
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getResource()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_getResource: (state, payload) => {

        state.vacations_activeResourceInformations = payload;
        state.vacations_activeResourceContractVacationDays = payload.contractVacationDays;
        state.vacations_activeResourceContractOffdayDays = payload.contractOffDaysMonth * 12;
        state.vacations_activeResourceGenChildren = payload.genChildren;
        state.vacations_activeResourceGenChildrenSchool = payload.genChildrenSchool !== null ? payload.genChildrenSchool : 0;

    }, // eo function mut_call_getResource()




    /***************************************************************************
    * mut_setResourceInformations()
    *
    * Desc:
    * Note:
    *
    */
    mut_setResourceInformations: (state, payload) => {

        state.vacations_fullMemberName = payload && payload.fullMemberName ? payload.fullMemberName : null;
        state.vacations_resourceId = payload && payload.idResource ? payload.idResource : null;

    }, // eo function mut_setResourceInformations()


    /***************************************************************************
    * mut_setVacationsSelectedYear()
    *
    * Desc:
    * Note:
    *
    */
    mut_setVacationsSelectedYear: (state, payload) => {

        state.vacations_selectedYear = payload;

    }, // eo function mut_setVacationsSelectedYear()




    /***************************************************************************
    * Mutations: 'Vacation Report'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getVacationReport()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_getVacationReport: (state, payload) => {

        let fullName = null;


        // >>> ---------------------------------- save params
        state.vacations_searchchParams = payload.params;


        // >>> ----------------------------------
        state.vacations_vacationReport = payload.payload.items;

        state.vacations_vacationReport.forEach((item, index) => {
            fullName = item.lastName.trim() + ', ' + item.firstName.trim();
            item.fullName = fullName;
            item.id = index; // item.key
        });

    }, // eo function mut_call_getVacationReport()


    /***************************************************************************
    * mut_setResource()
    *
    * Desc:
    * Note:
    *
    */
    mut_setResource: (state, payload) => {

        state.vacations_searchchParamsResource = payload.payload;

    }, // eo function mut_setResource()




    /***************************************************************************
    * Mutations: 'Vacation Report' reset
    ***************************************************************************/
    /***************************************************************************
    * mut_reset_VacationStuff()
    *
    * Desc:
    * Note:
    *
    */
    mut_reset_VacationStuff: (state, payload) => {

        state.vacations_combinedVacations =  []; // reset
        state.vacations_numberOfVacations = 0;
        state.vacations_activeResourceContractVacationDays = 0;
        state.vacations_activeResourceContractOffdayDays = 0;
        state.vacations_activeResourceGenChildren = 0;
        state.vacations_activeResourceGenChildrenSchool = 0;
        state.vacations_numberOfOffdays = 0;
        state.vacations_numberOfIllness = 0;
        state.vacations_numberOfUnableToFly = 0;

        eventBus.$emit('combinedvacationsdone');

    }, // eo function mut_reset_VacationStuff()

};





//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Vacations' - Load Department(s)
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/resource/department/' + idDepartment;
    *
    * Desc: Call: Get List of Departments Ressources.
    * Note: There are to simultaneously Department Calls.
    * Note: Therefore thjis stupid Hack here.
    * Note: e.g.: payload => { department: '12', secondLoad: true }
    *
    */
    actn_call_getResourcesOfDepartment: (context, payload) => {

        let hdrs = '';


        axios.get('/humanresources/resource/department/' + payload.department)
            .then(function (response) { // 'OK'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_ResourcesOfDepartment', { response: response.data, secondLoad: payload.secondLoad, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                if (payload.secondLoad) {
                    Vue.prototype.$vp_um();
                }
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getResourcesOfDepartment()




    /***************************************************************************
    * Actions: 'Vacations' - Load Vacations/Offdays/Illness
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/resource/vacation/' + idDepartment + '/' + year
    *
    * Desc: Call: Get List of Vacation Days of Ressource.
    * Note:
    *
    */
    actn_call_getVacationsOfResource: (context, payload) => {

        let hdrs = '';


        context.state.vacations_callCounter = 0; // reset counter

        Vue.prototype.$vp_m();
        axios.get('/humanresources/resource/vacation/' + payload.id + '/' + payload.year)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_VacationsOfResource', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$vp_um();
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getVacationsOfResource()




    /***************************************************************************
    * Actions: 'Offdays' - Load Vacations/Offdays/Illness
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/resource/offday/' + idDepartment + '/' + year
    *
    * Desc: Call: Get List of Offdays of Ressource.
    * ToDo: Year into Paylod.
    *
    */
    actn_call_getOffdaysOfResource: (context, payload) => {

        let hdrs = '';


        // Vue.prototype.$vp_m();
        axios.get('/humanresources/resource/offday/' + payload.id + '/' + payload.year)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_OffdaysOfResource', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$vp_um();
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getOffdaysOfResource()


    /***************************************************************************
    * Actions: 'Illness' - Load Vacations/Offdays/Illness
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/resource/illness/' + idDepartment + '/' + year
    *
    * Desc: Call: Get List of Offdays of Ressource.
    * Note:
    *
    */
    actn_call_getIllnessOfResource: (context, payload) => {

        let hdrs = '';


        // Vue.prototype.$vp_m();
        axios.get('/humanresources/resource/illness/' + payload.id + '/' + payload.year)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_set_IllnessOfResource', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$vp_um();
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getIllnessOfResource()


    /***************************************************************************
    * Actions: 'UnableToFly' - Load Vacations/Offdays/Illness
    ***************************************************************************/
    /***************************************************************************
    * Call::'humanresources/resource/unabletofly/' + idDepartment + '/' + year
    *
    * Desc: Call: Get List of unable to fly days of Ressource.
    * Note:
    *
    */
    actn_call_getUnableToFlyOfResource: (context, payload) => {

        let hdrs = '';


        // Vue.prototype.$vp_m();
        axios.get('/humanresources/resource/unabletofly/' + payload.id + '/' + payload.year)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getUnableToFlyOfResource', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$vp_um();
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getUnableToFlyOfResource()




    /***************************************************************************
    * Actions: 'Ressource' - Load Ressource
    ***************************************************************************/
    /***************************************************************************
    * Call::''
    *
    * Desc:
    * Note:
    *
    */
    actn_call_getResource: (context, payload) => {

        let hdrs = '',
            url = '/humanresources/resource/' + payload;


        // >>> Send Ajax Request --------------------------
        // Vue.prototype.$vp_m();
        axios.get(url)
            .then(function (response) { // 'OK'
                // Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getResource', response.data);

                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                // Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getResource()




    /***************************************************************************
    * Actions: 'Vacations'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/resource/break'
    *
    * Desc: Call:
    * Note: 'Single Breaks' means: Date => from/to
    *
    */
    actn_call_createSingleVacations: (context, payload) => {

        let hdrs = '';


        Vue.prototype.$vp_m();
        axios.put('/humanresources/resource/break', payload.payload)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_createSingleVacations', { payload: response.data, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            })
            .finally(() => {
                Vue.prototype.$vp_um();
            });

    }, // eo function actn_call_createSingleVacations()


    /***************************************************************************
    * Call::'humanresources/resource/break/multi'
    *
    * Desc: Call: '/humanresources/resource/break/multi'
    * Note: 'Multi Breaks' means: Single Breaks w. diff. Dates.

    *
    */
    actn_call_createMultiVacations: (context, payload) => {

        let hdrs = '';


        Vue.prototype.$vp_m();
        axios.put('/humanresources/resource/break/multi', payload.payload)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_createMultiVacations', { payload: response.data, context: context, editorMode: payload.editorMode  });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            })
            .finally(() => {
                Vue.prototype.$vp_um();
            });

    }, // eo function actn_call_createMultiVacations()


    /***************************************************************************
    * Call::'humanresources/delete/multi'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_deleteMultiVacations: (context, payload) => {

        let hdrs = '';


        Vue.prototype.$vp_m();
        axios.put('humanresources/delete/multi', payload)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_deleteMultiVacations', { payload: payload, context: context });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            })
            .finally(() => {
                Vue.prototype.$vp_um();
            });

    }, // eo function actn_call_deleteMultiVacations()


    /***************************************************************************
    * Call::'/humanresources/resource/break/' + idBreak
    *
    * Desc: Call:
    * Note:
    *
    */
    actn_call_deleteVacations: (context, payload) => {

        return new Promise((resolve) => {

            let hdrs = '';


            Vue.prototype.$vp_m();
            axios.delete('/humanresources/resource/break/' + payload)
                .then(function (response) { // 'OK'
                    hdrs = response.headers["air41-status"];
                    switch (hdrs) {
                        case 'OK': // 'OK'
                            context.commit('mut_call_deleteVacations', { payload: response.data, context: context });
                            break;
                        default: // 'ERROR'
                            Vue.prototype.$toasted.global.sdr_app_error({
                                message: response.headers["air41-error"]
                            });
                            break;
                    }
                })
                .catch(function (error) { // 'ERROR'
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Service unavailable: ' + error
                    });
                })
                .finally(() => {
                    Vue.prototype.$vp_um();
                    resolve();
                });

        });

    }, // eo function actn_call_deleteVacations()


    /***************************************************************************
    * actn_setResourceInformations()
    *
    * Desc:
    * Note:
    *
    */
    actn_setResourceInformations: (context, payload) => {

        context.commit('mut_setResourceInformations', payload);
        context.commit('mut_reset_VacationStuff'); // reset

    }, // eo function actn_setResourceInformations()


    /***************************************************************************
    * actn_setVacationsSelectedYear()
    *
    * Desc:
    * Note:
    *
    */
    actn_setVacationsSelectedYear: (context, payload) => {

        context.commit('mut_setVacationsSelectedYear', payload);

    }, // eo function actn_setVacationsSelectedYear()




    /***************************************************************************
    * Actions: 'Vacation Report'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/humanresources/resource/vacation/report'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_getVacationReport: (context, payload) => {

        let hdrs = '';


        if (payload !== undefined) { //
            payload.idresources = context.state.vacations_searchchParamsResource;
        }

        if (payload === undefined) { //
            payload = context.state.vacations_searchchParams;
            payload.idresources = context.state.vacations_searchchParamsResource;;
        }


        // >>> ---------------------------------- run
        Vue.prototype.$vp_m();
        axios.put('/humanresources/resource/vacation/report', payload)
            .then(function (response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_call_getVacationReport', { payload: response.data, context: context, params: payload });
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                }
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            })
            .finally(() => {
                Vue.prototype.$vp_um();
            });

    }, // eo function actn_call_getVacationReport()


    /***************************************************************************
    * actn_setResource()
    *
    * Desc:
    * Note:
    *
    */
    actn_setResource: (context, payload) => {

        context.commit('mut_setResource', { payload: payload, context: context });

        context.dispatch("actn_call_getVacationReport");

    }, // eo function actn_setResource()




    /***************************************************************************
    * Actions: 'Vacation Report Download'
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/humanresources/resource/invoicing/download'
    *
    * Desc:
    *
    */
    actn_call_download_VacationReport: (context, payload) => {

        let url = '',
            xhr = null;


        url = '/rest/humanresources/resource/vacation/reportascsv';
        xhr = new XMLHttpRequest();
        xhr.open("PUT", url);
        xhr.setRequestHeader("apiKey", '037ae1f2ba244a2a93b24121743bfdd6');
        xhr.setRequestHeader("Authorization", payload.authheader);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                var blob = new Blob([xhr.response], { type: "application/csv" });
                var objectUrl = URL.createObjectURL(blob);
                window.open(objectUrl);
            }
        };
        xhr.send(JSON.stringify(payload.params));

    }, // eo function actn_call_download_VacationReport()

};





//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};